import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

export default function Sidebar({ activeTab, setActiveTab }) {
  const tabs = [
    { id: 'pass1', label: 'Pass 1: Structure', sub: 'Macro Edit', icon: FiIcons.FiLayout },
    { id: 'pass2', label: 'Pass 2: Sentence', sub: 'Micro Edit', icon: FiIcons.FiEdit2 },
  ];

  return (
    <div className="w-full md:w-64 flex-shrink-0">
      <div className="md:sticky md:top-28 flex flex-col gap-2">
        <div className="mb-6 hidden md:block">
          <h2 style={{
      color: 'rgb(107, 114, 128)',
      fontSize: '14px'
    }} className="text-xs font-bold uppercase tracking-widest text-gray-500 mb-2">Navigation</h2>
          <div className="h-px w-full bg-black"></div>
        </div>
        
        <div className="flex flex-row md:flex-col gap-2 overflow-x-auto md:overflow-visible pb-2 md:pb-0">
          {tabs.map(tab => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`flex items-center gap-3 p-4 text-left transition-all border-2 whitespace-nowrap md:whitespace-normal ${
                activeTab === tab.id
                  ? 'border-black bg-white shadow-brutal-sm translate-y-[-2px]'
                  : 'border-transparent hover:border-gray-300 hover:bg-white text-gray-500'
              }`}
            >
              <SafeIcon
                icon={tab.icon}
                className={`text-xl ${activeTab === tab.id ? (tab.id === 'pass1' ? 'text-orange' : 'text-blue') : ''}`}
              />
              <div>
                <div className={`font-bold uppercase tracking-wide text-sm ${activeTab === tab.id ? 'text-black' : ''}`}>
                  {tab.label}
                </div>
                <div style={{
      fontSize: '12px',
      fontWeight: '500'
    }} className="text-[10px] uppercase tracking-widest mt-0.5">
                  {tab.sub}
                </div>
              </div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}